import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ExamAuthProtected = ({ children, authenticate = true }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const localDetails = JSON.parse(localStorage.getItem("practido-examAuth"));
    if (localDetails) {
      const isLoggedIn = localDetails.isCandidateLogin;
      if (authenticate && !isLoggedIn) {
        navigate("/exam/login");
      } else if (!authenticate && isLoggedIn) {
        navigate("/exam/setup");
      }
    }
  }, [authenticate, navigate]);
  return children;
};

export default ExamAuthProtected;
